import { generateNormalReadingsMessage } from '../blurbs';

import type { IUseNormalReadingsProps, INormalReadingsValues } from '../types';

export const useNormalReadings = ({
  closeModal,
  handleSubmit,
  whichPerson,
  otherPerson,
}: IUseNormalReadingsProps) => {
  const initialValues: INormalReadingsValues = {
    readingTypes: [],
    doingDifferently: [],
    patientGoalSetting: '',
    hasQuestions: null,
    questions: '',
    reminderTakeReadingsRegularly: [],
    reminderMonitorHealthConditions: [],
    needConsumables: null,
    verifiedAddress: [],
    transferCallToNursingTeam: [],
    additionalDetails: '',
    whichPerson,
    otherPerson,
  };

  const preparedData = (data: INormalReadingsValues) => {
    const formData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== null),
    );

    return {
      readingTypes: formData.readingTypes,
      doingDifferently: formData.doingDifferently,
      patientGoalSetting: formData.patientGoalSetting,
      hasQuestions: formData.hasQuestions,
      questions: formData.questions,
      reminderTakeReadingsRegularly: formData.reminderTakeReadingsRegularly,
      reminderMonitorHealthConditions: formData.reminderMonitorHealthConditions,
      needConsumables: formData.needConsumables,
      verifiedAddress: formData.verifiedAddress,
      transferCallToNursingTeam: formData.transferCallToNursingTeam,
      additionalDetails: formData.additionalDetails,
      whichPerson: formData.whichPerson,
      otherPerson: formData.otherPerson,
    };
  };

  const onSaveForm = (formData: INormalReadingsValues) => {
    const preparedValues = preparedData(formData);

    const filteredValues = Object.fromEntries(
      Object.entries(preparedValues).filter(([_, value]) => value !== null),
    ) as INormalReadingsValues;

    const message = generateNormalReadingsMessage(filteredValues);

    handleSubmit(message);
    closeModal();
  };

  return {
    initialValues,
    onSaveForm,
  };
};
